<div [formGroup]="parentForm">
    <mat-form-field style="margin: 5px; width: 100%;" *ngIf="!isKendo">
        <input matInput #autoTrigger="matAutocompleteTrigger"
               [placeholder]="placeholder"
               [formControlName]="ctrlName"
               [attr.aria-label]="ariaLabel"
               [matAutocomplete]="carrier"
               [attr.disabled]="isDisabled"
               [attr.required]="isRequired"
               (keydown.enter)="$event.preventDefault(); chooseActiveCarrier($event)"
               (keydown.Tab)="chooseActiveCarrier($event)"
               (blur)="optionBlurred()" [(ngModel)]="displayValue">
        <mat-autocomplete #carrier="matAutocomplete" [displayWith]="displayCarrier" (optionSelected)="optionChanged($event)" (focusout)="optionBlurred()">
            <mat-option *ngFor="let carrier of filteredCarriers" [value]="carrier">
                {{ displayCarrier(carrier) }}
            </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="!isValid()">{{errorDetail}}</mat-error>
    </mat-form-field>
    <div *ngIf="isKendo">
        <!--https://www.telerik.com/kendo-angular-ui/components/dropdowns/autocomplete/filtering/-->
        <kendo-autocomplete [data]="filteredCarriers"
                            [formControlName]="ctrlName"
                            valueField="carrierCode"
                            [filterable]="true"
                            (filterChange)="getCarrierLookup($event)"
                            (valueChange)="optionChanged($event)"
                            class="form-control"
                            placeholder="{{placeholder}}">
            <ng-template kendoAutoCompleteItemTemplate let-dataItem>
                <!--<div style="line-height:1.2;height:50px;">-->
                    <!--{{dataItem.carrierCode}} - {{dataItem.name}}<br />
        <small style="color:#999999;">{{dataItem.address1}}, {{dataItem.cityST}}</small>-->
                <!--</div>-->
                <div style="margin-bottom:10px;">
                    {{displayCarrier(dataItem)}}
                </div>
            </ng-template>
        </kendo-autocomplete>
    </div>
</div>
